var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2207 0C5.03694 0 0 5.03529 0 11.2171C0 17.3988 5.03694 22.4441 11.2207 22.4441C13.8617 22.4441 16.291 21.5191 18.2106 19.9822L22.8846 24.6523C23.3826 25.1303 24.1735 25.1139 24.6516 24.6167C25.1157 24.1334 25.1163 23.3708 24.6528 22.887L19.9788 18.2146C21.5168 16.2927 22.4438 13.8606 22.4438 11.2171C22.4438 5.03529 17.404 0 11.2207 0ZM11.2207 2.4934C16.0566 2.4934 19.9473 6.38279 19.9473 11.2171C19.9473 16.0514 16.0566 19.9507 11.2207 19.9507C6.38488 19.9507 2.49421 16.0514 2.49421 11.2171C2.49421 6.38279 6.38488 2.4934 11.2207 2.4934Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.07275c3b866a069a34e6370c41c03530.svg";
export { ForwardRef as ReactComponent };